// What "Trusted by" calls each organisation. The API stores only the logo's
// file, so until it stores a name too (name), the CMS shows the file's name,
// and says when that is a file name rather than the organisation's.

// "image/nucleus ventures logo-1751366503545.png" → "Nucleus ventures logo".
export function logoName(path) {
  const base = String(path || "")
    .split("/")
    .pop()
    .replace(/\.[a-z0-9]+$/i, "")
    .replace(/-\d{10,}$/, "")
    .replace(/[_-]+/g, " ")
    .trim();
  return base ? base.charAt(0).toUpperCase() + base.slice(1) : "Logo";
}

// The organisation's name when the API sends one, otherwise the file's.
export const organisationName = (item) => (typeof item?.name === "string" && item.name.trim() ? item.name.trim() : logoName(item?.image));

// Whether this API stores organisation names at all.
export const namesSupported = (items) => (items || []).some((item) => item && "name" in item);

// A name that reads like a file, not an organisation: "BT Logo",
// "IPark New Logo Branding", "darwazah.png", "IMG_2041", "Screenshot 2025".
const FILE_WORDS = /\b(logo|logos|branding|brand ?mark|icon|img|image|screenshot|final|copy|v\d+)\b/i;
export function looksLikeFileName(name) {
  const text = String(name || "").trim();
  if (!text) return false;
  return FILE_WORDS.test(text) || /\.(png|jpe?g|svg|gif|webp|bmp|tiff?)$/i.test(text) || /\d{6,}/.test(text) || /_/.test(text);
}
